/**
 * Custom Cursor
 * Menggerakkan lingkaran (#customCursor) mengikuti posisi mouse dengan efek
 * lerp (linear interpolation) yang dihaluskan lewat requestAnimationFrame,
 * lalu menuliskan hasilnya ke CSS custom properties --x dan --y.
 *
 * Lingkaran hanya diaktifkan saat mouse benar-benar berada di atas backdrop
 * overlay/drawer/modal yang AKTIF (opacity > 0 dan pointer-events tidak
 * "none") — bukan sekadar berada di dalam elemen yang punya class trigger,
 * supaya:
 * 1) Icon/tombol pembuka drawer (cart, filter, sort, dll) tidak ikut
 *    mengaktifkan cursor sebelum drawer-nya benar-benar terbuka.
 * 2) Konten di dalam modal (mis. isi Quickview / popup) tidak dianggap
 *    sebagai area "klik untuk menutup", sehingga cursor kembali normal
 *    saat diarahkan ke konten tersebut.
 */
(function () {
  'use strict';

  var cursor = document.getElementById('customCursor');
  if (!cursor) return;

  // 'pseudo' -> cursor asli berada di ::after (backdrop dibuat dari elemen trigger itu sendiri)
  var PSEUDO_TRIGGERS = '.overlay, .overlayminicart';
  // 'self' -> cursor asli berada langsung di elemen tersebut
  var SELF_TRIGGERS = '.overlay_search, .tingle-modal';

  // Area konten yang TIDAK boleh mengaktifkan cursor close meskipun berada
  // di dalam elemen trigger (misalnya isi modal quickview/popup yang bisa
  // diklik secara normal, bukan untuk menutup modal).
  var IGNORE_SELECTOR = '.tingle-modal-box';

  var mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  var pos = { x: mouse.x, y: mouse.y };
  var LERP_FACTOR = 0.15; // 0 = diam, 1 = langsung nempel tanpa smoothing

  function lerp(start, end, amount) {
    return start + (end - start) * amount;
  }

  function tick() {
    pos.x = lerp(pos.x, mouse.x, LERP_FACTOR);
    pos.y = lerp(pos.y, mouse.y, LERP_FACTOR);
    cursor.style.setProperty('--x', pos.x + 'px');
    cursor.style.setProperty('--y', pos.y + 'px');
    requestAnimationFrame(tick);
  }

  function handleMouseMove(event) {
    mouse.x = event.clientX;
    mouse.y = event.clientY;
  }

  // Cek apakah backdrop (::after atau elemen itu sendiri) sedang benar-benar
  // aktif/interaktif saat ini (opacity > 0 dan pointer-events bukan "none").
  function isBackdropActive(el, usePseudo) {
    var style = usePseudo
      ? window.getComputedStyle(el, '::after')
      : window.getComputedStyle(el);
    if (!style) return false;
    return style.pointerEvents !== 'none' && parseFloat(style.opacity) > 0;
  }

  // Telusuri ke atas dari elemen yang di-hover untuk mencari trigger yang
  // benar-benar aktif, sambil menghormati area yang dikecualikan.
  function findActiveTrigger(target) {
    var el = target;
    while (el && el.nodeType === 1) {
      if (typeof el.matches === 'function') {
        if (el.matches(IGNORE_SELECTOR)) return null;
        if (el.matches(PSEUDO_TRIGGERS) && isBackdropActive(el, true)) return el;
        if (el.matches(SELF_TRIGGERS) && isBackdropActive(el, false)) return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  function updateCursorState(target) {
    var active = findActiveTrigger(target);
    cursor.classList.toggle('is-active', !!active);
  }

  window.addEventListener('mousemove', handleMouseMove, { passive: true });

  document.addEventListener('mouseover', function (event) {
    updateCursorState(event.target);
  });

  document.addEventListener('mouseout', function (event) {
    updateCursorState(event.relatedTarget || null);
  });

  window.addEventListener('blur', function () {
    cursor.classList.remove('is-active');
  });

  requestAnimationFrame(tick);
})();
